var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhatsappIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#3cb5ea;}.b{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-187 -401)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 19.5,
    cy: 19.5,
    r: 19.5,
    transform: "translate(187 401)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(195 409)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M91.562,86.714c-.044-.021-1.674-.824-1.963-.928a1.128,1.128,0,0,0-.38-.084.646.646,0,0,0-.549.325c-.163.242-.656.818-.808.99-.02.023-.047.05-.063.05s-.267-.1-.343-.137A8.578,8.578,0,0,1,84.2,84.036a.18.18,0,0,1-.027-.064.526.526,0,0,1,.1-.113c.089-.088.185-.2.278-.316.044-.053.088-.106.132-.156a1.756,1.756,0,0,0,.265-.42l.037-.073a.76.76,0,0,0-.022-.715c-.039-.077-.727-1.738-.8-1.913-.176-.421-.408-.617-.732-.617-.03,0,0,0-.126.005A3.907,3.907,0,0,0,81.942,80a2.837,2.837,0,0,0-1.052,2.414,5.2,5.2,0,0,0,1.128,2.864l.046.067A10.619,10.619,0,0,0,86.619,89.3a7.407,7.407,0,0,0,2.751.7h0a4.3,4.3,0,0,0,.448-.026l.08-.008a2.892,2.892,0,0,0,2.016-1.427,2.256,2.256,0,0,0,.128-1.485A1.029,1.029,0,0,0,91.562,86.714Z",
    transform: "translate(-75.018 -73.866)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M11.378,0A10.953,10.953,0,0,0,.4,10.9,10.819,10.819,0,0,0,1.9,16.411L.016,21.975a.29.29,0,0,0,.363.37L6.18,20.5a11,11,0,0,0,16.179-9.6A10.953,10.953,0,0,0,11.378,0Zm0,19.527A8.7,8.7,0,0,1,6.592,18.1a.29.29,0,0,0-.247-.034l-2.906.924.938-2.768a.29.29,0,0,0-.041-.265A8.511,8.511,0,0,1,2.679,10.9a8.7,8.7,0,1,1,8.7,8.628Z",
    transform: "translate(0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsappIcon);
export default __webpack_public_path__ + "static/media/whatsappIcon.d5f5facca97b1a6e30fcf0bea4f18504.svg";
export { ForwardRef as ReactComponent };